export default __webpack_public_path__ + "static/media/82F16F1B-F419-45BB-81DF-00B60DF7F841_1_105_c.40d98468.jpeg";